
<div class="col-sm-6 col-sm-offset-3" style="margin-top:48px;">
    <div style="margin-top: 8px;">
        <div class="page-title">Reset Password</div>
        <div class="alert alert-success" *ngIf="email || phone">
            <div>A security code is required to reset your password. Security code is already send</div>
            <div *ngIf="email">{{'to email '+email}}</div>
            <div *ngIf="phone ">{{'and phone no '+phone+'. Please use the code to reset your password.'  }}</div>
            <div>Password length should be minimum 8 character and password should be alphanumeric.</div>
            <div>Password Should have to at lease a uppercase, lowercase, digit or #$!%*?& and make sure the length is min 8 in length.</div>
        </div>
        <div class="panel">
            <div class="panel-body">
                <div class="col-xs-12 label-text">
                    <div class="col-xs-4  label-text-right">Security Code / OTP</div>
                    <div class="col-xs-8 ">
                        <dx-text-box [(ngModel)]="data.SecurityCode" (onValueChanged)="checkPasswordMismatched()">
                        </dx-text-box>
                    </div>
                </div>
                <div class="col-xs-12 label-text">
                    <div class="col-xs-4  label-text-right">New Password</div>
                    <div class="col-xs-8">
                        <dx-text-box [(ngModel)]="data.NewPassword" (onValueChanged)="newPasswordChanged()">
                        </dx-text-box>
                        <div style="color:red;" *ngIf="newPasswordErrorMessage && newPasswordErrorMessage.length > 0">
                            {{newPasswordErrorMessage}}</div>
                    </div>
                </div>
                <div class="col-xs-12 label-text">
                    <div class="col-xs-4  label-text-right">Confirm Password</div>
                    <div class="col-xs-8 ">
                        <dx-text-box [(ngModel)]="data.ConfirmPassword" (onValueChanged)="confirmPasswordChanged()">
                        </dx-text-box>
                        <div style="color:red;"
                            *ngIf="confirmPasswordErrorMessage && confirmPasswordErrorMessage.length > 0">
                            {{confirmPasswordErrorMessage}}</div>
                    </div>
                </div>
                <div class="col-xs-12 label-text">
                    <div class="label-text col-sm-4 pull-right">
                        <dx-button width="100%" [disabled]="!canChangePassword" text="Reset Password"
                            (click)="resetPassword($event)" type="success"></dx-button>
                    </div>
                </div>
                <div class="col-xs-12 label-text">
                    <div class="col-xs-12 label-text">
                        <div *ngIf="successMessage && successMessage.length > 0" class="alert alert-success">
                            {{successMessage}}</div>
                        <div *ngIf="errorMessage && errorMessage.length > 0" class="alert alert-danger">{{errorMessage}}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>